import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteBlogPostBuilderDraft($projectId: ID!, $draftId: ID!) {
    deleteBlogPostBuilderDraft(projectId: $projectId, draftId: $draftId) {
      id
    }
  }
`;

interface Params {
  projectId: ID;
  draftId: ID;
}

export const deleteBlogPostBuilderDraft = async ({ projectId, draftId }: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, draftId },
  });

  return getSingleProp<Entity>(result.data);
};
